document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formAgregarTiempoMuertoSoplado') return;

    e.preventDefault();

    const formulario = e.target;

    if (!formulario.querySelector('#idEncabezadoReporteSoplado')) return;
    const modalPadre = formulario.closest('.modal');
    const btnSubmit = formulario.querySelector('#btnAgregarTiempoMuertoSoplado');
    const spinner = btnSubmit ? btnSubmit.querySelector('#spinner') : formulario.querySelector('#spinner');

    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    if (btnSubmit) btnSubmit.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(function (input) {
        input.classList.remove('inputRojo');
    });

    try {
        const formData = new FormData(formulario);

        const respuesta = await fetch('/api/soplado/agregar-tiempo-muerto', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json = null;

        try {
            json = await respuesta.json();
        } catch (errorJson) {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            } else {
                alert('Error al procesar la solicitud.');
            }

            return;
        }

        if (!json || !json.result) {
            console.error('Respuesta inesperada:', json);
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            }
            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') {
                        lanzarAlerta(
                            error.mensaje || 'Error de validación.',
                            error.clase || 'alerta-roja'
                        );
                    }

                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }

            return;
        }

        const inputReporte = formulario.querySelector('#idEncabezadoReporteSoplado');
        const idReporte = inputReporte ? inputReporte.value : '';

        const params = new URLSearchParams(window.location.search);
        const mes = params.get('mes');
        const anio = params.get('año');

        formulario.reset();

        if (modalPadre) modalPadre.classList.remove('modal--show');

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Registro guardado con éxito.', 'alerta-verde');
        }

        if (typeof window.actualizarModalReporteSoplado === 'function') {
            window.actualizarModalReporteSoplado(idReporte);
        }

        if (typeof window.actualizarTableroSopladoPeriodo === 'function') {
            window.actualizarTableroSopladoPeriodo(mes, anio);
        }

        if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
            window.actualizarTablaSopladoPeriodo(mes, anio);
        }

        if (typeof window.actualizarZonaTrabajo === 'function') {
            if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
        }

    } catch (error) {
        console.error('Error:', error);

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }

    } finally {
        if (btnSubmit) btnSubmit.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});